<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <h6 class="esep-blue-color float-left font-weight-bold">
          {{ $t("roleManagement.userRole") }}
        </h6>

        <b-alert
          class="float-right"
          v-model="showSuccess"
          variant="success"
          dismissible
        >
          {{ $t("roleManagement.success") }}
        </b-alert>
        <b-alert
          class="float-right"
          v-model="showFailed"
          variant="danger"
          dismissible
        >
          {{ $t("roleManagement.chooseUser") }}
        </b-alert>
      </div>
      <div class="float-right ml-auto mr-3 mb-2">
        <b-modal
          id="add-role-modal"
          :title="$t('roleManagement.confirmRole')"
          v-model="show"
          no-close-on-backdrop
        >
          <p class="my-4">
            {{ $t("roleManagement.chooseRoleToAdd") }}
          </p>
          <b-form-select
            :options="roles"
            v-model="roleToAdd"
            :state="roleState"
            required
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>{{
                $t("roleManagement.chooseRole")
              }}</b-form-select-option>
            </template>
          </b-form-select>
          <template
            v-if="
              this.selectedUnit != null &&
              roleToAdd != 'Διαχειριστής Εφαρμογών E-SEP' &&
              roleToAdd != 'Διαχειριστής Οικονομικής Υπηρεσίας ΣΕΠ' &&
              roleToAdd != 'Διαχειριστής Εφορείας Εκπαίδευσης ΓΕ' &&
              roleToAdd != 'Εκπαιδευτής' &&
              roleToAdd != 'Κυβερνήτης'
            "
          >
            <b-form-group
              :label="$t('common.unit')"
              label-for="unit-select"
              label-align="left"
              class="mt-2"
            >
              <v-select
                id="unit-select"
                :options="accessibleUnits"
                :placeholder="$t('roleManagement.chooseUnit')"
                v-model="selectedUnit"
              >
                <template #no-options="{}">
                  {{ $t("roleManagement.noUnitsWithCriteria") }}
                </template>
              </v-select>
            </b-form-group>
          </template>
          <template v-slot:modal-footer="{ cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" variant="success" @click="addRole()">
              {{ $t("common.add") }}
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
              {{ $t("common.cancel") }}
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <b-table
      striped
      hover
      borderless
      :items="computedItems"
      :fields="fields"
      show-empty
      rounded
      responsive
      thead-class="esep-blue-bg text-light"
    >
      <template v-slot:cell(role)="row">
        {{ row.item.role_name }}
      </template>

      <template v-slot:cell(username)="row">
        {{ row.item.username }}
      </template>

      <template v-slot:cell(delete)="row">
        <b-button size="sm" variant="transparent" @click="showDeleteModal(row)">
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        {{ $t("roleManagement.noRolesForUser") }}
      </template>
    </b-table>
    <b-row class="d-flex justify-content-start align-items-left">
        <b-button
            @click="showAddModal"
            variant="primary"
            class="esep-blue-bg"
            style="margin-left: 1em"
        >{{ $t("roleManagement.addRole") }}</b-button
        >

        <b-button
            @click="activateUser"
            variant="primary"
            class="esep-blue-bg"
            style="margin-left: 1em"
        >{{ this.user.enabled? $t("roleManagement.deactivateUser"): $t("roleManagement.activateUser") }}</b-button
        >

        <b-button
            v-if="!this.user.emailVerified"
            @click="verifyUser"
            variant="primary"
            class="esep-blue-bg"
            style="margin-left: 1em"
        >{{ $t("roleManagement.verifyUser") }}</b-button
        >
    </b-row>
    <b-modal
      id="delete-modal"
      :title="$t('common.deleteCard')"
      no-close-on-backdrop
    >
      <template
        v-if="
          this.userPermissionUnits != null &&
          roleToDelete != 'ADMIN' &&
          roleToDelete != 'FINANCE_ADMIN' &&
          roleToDelete != 'TRAINING_ADMIN' &&
          roleToDelete != 'CAPTAIN' &&
          roleToDelete != 'TRAINER'
        "
      >
        <b-form-group
          :label="$t('common.unit')"
          label-for="unit-select"
          label-align="left"
          class="mt-2"
        >
          <v-select
            id="unit-select"
            :options="userPermissionUnits"
            :placeholder="$t('roleManagement.chooseUnit')"
            v-model="selectedPermissionUnit"
          >
            <template #no-options="{}">
              {{ $t("roleManagement.noUnitsWithCriteria") }}
            </template>
          </v-select>
        </b-form-group>
      </template>
      <p class="my-4">
        {{ $t("roleManagement.deleteRole")
        }}<template
          v-if="
            roleToDelete != 'ADMIN' &&
            roleToDelete != 'FINANCE_ADMIN' &&
            roleToDelete != 'CAPTAIN' &&
            roleToDelete != 'TRAINING_ADMIN' &&
            roleToDelete != 'TRAINER'
          "
        >
          {{ $t("roleManagement.deleteRoleUnit") }}</template
        >
      </p>
      <template v-slot:modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="deleteConfirmed()">
          {{ $t("common.yes") }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          {{ $t("common.cancel") }}
        </b-button>
      </template>
    </b-modal>
    <hr />
  </div>
</template>



<script>
import EsepService from "@/services/esep.service.js";
import esepService from "../../services/esep.service";
import {makeErrorToast, makeToast} from "@/services/error.service";

export default {
  props: {
    userRoles: {
      type: Array
    },
    user: {
      type: Object
    }
  },
  computed: {
    computedItems: function () {
      let roleName = "";
      var rolesOfEachUser = [];
      let roles = this.userRoles;
      roles.forEach(function (role) {

        if (role.name == "USER") {
          roleName = "Χρήστης";
        } else if (role.name == "ADMIN") {
          roleName = "Διαχειριστής Εφαρμογών E-SEP";
        } else if (role.name == "UNIT_ADMIN") {
          roleName = "Διαχειριστής Κλιμακίου";
        } else if (role.name == "UNIT_MOD") {
          roleName = "Συντονιστής Κλιμακίου";
        } else if (role.name == "TRAINING_ADMIN") {
          roleName = "Διαχειριστής Εφορείας Εκπαίδευσης ΓΕ";
        } else if (role.name == "FINANCE_ADMIN") {
          roleName = "Διαχειριστής Οικονομικής Υπηρεσίας ΣΕΠ";
        } else if (role.name == "TRAIN_MOD") {
          roleName = "Συντονιστής Εκπαίδευσης";
        } else if (role.name == "TRAINER") {
          roleName = "Εκπαιδευτής";
        } else if (role.name == "UNIT_VIEWER") {
          roleName = "Επόπτης Κλιμακίου";
        } else if (role.name == "TROOP_ADMIN") {
          roleName = "Διαχειριστής Τμήματος";
        } else if (role.name == "CAPTAIN") {
          roleName = "Κυβερνήτης";
        } else if (role.name == "COMMISSION_PRESIDENT") {
          roleName = "Πρόεδρος Ε.Κ.Σ.";
        } else if (role.name == "EXCURSION_VIEWER") {
          roleName = "Επόπτης Δελτίων Εκδρομών";
        } else if (role.name == "AFFAIRS_COMMISSIONER") {
          roleName = "Συντονιστής Εφορείας Διεθνών Σχέσεων";
        } else if (role.name == "NAVY_COMMISSIONER") {
          roleName = "Συντονιστής Ειδικότητας Ναυτοπροσκόπων";
        } else if (role.name == "BRANCH_COMMISSIONER") {
          roleName = "Έφορος Κλάδου";
        } else if (role.name == "AIR_COMMISSIONER") {
          roleName = "Συντονιστής Ειδικότητας Αεροπροσκόπων";
        }
        let unitName = "";
        if (role.units) {
          if (role.units.length == 1) {
            unitName = role.units[0].name;
          } else if (role.units.length == 0) {
            unitName = "-";
          } else {
            for (let i = 0; i < role.units.length; i++) {
              const unit = role.units[i];
              unitName += unit.name;
              if (i < role.units.length - 1) {
                unitName += ", ";
              }
            }
          }
        } else {
          unitName = "-";
        }

        let distinctRoleObj = {
          role_name: roleName,
          unit: unitName,
        };
        rolesOfEachUser.push(distinctRoleObj);
      });
      this.extractRolesOfEachUser(rolesOfEachUser);

      return rolesOfEachUser;
    },
    accessibleUnits: function () {
      let units = [];
      for (let i = 0; i < this.$store.state.usersAccessibleUnits.length; i++) {
        const orgUnitName = this.$store.state.usersAccessibleUnits[i].name;
        const orgUnitId = this.$store.state.usersAccessibleUnits[i].id;
        const orgUnitType = this.$store.state.usersAccessibleUnits[i].type;
        const unit = { label: orgUnitName, id: orgUnitId, type: orgUnitType };
        units.push(unit);
      }
      return units;
    },
  },
  mounted() {
    this.accessibleUnits.forEach((unit) => {
      if (this.$store.state.userInfo.orgMember.orgUnit.id == unit.id) {
        this.selectedUnit = unit;
      }
    });
  },
  data() {
    return {
      fields: [
        {
          key: "role",
          label: "Ρόλος",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "unit",
          label: "Κλιμάκιο",
          thClass: "text-left",
          tdClass: "text-left",
        },
        { key: "delete", label: "Διαγραφή Ρόλου" },
      ],
      selectedUser: [],
      show: false,
      roles: [],
      errorMessage: "",
      roleToAdd: null,
      roleState: null,
      rolesOfEachUser: [],
      showSuccess: false,
      showFailed: false,
      showWarning: false,
      selectedUnit: null,
      userPermissionUnits: null,
      selectedPermissionUnit: null,
      roleToDelete: null,
    };
  },
  methods: {
    showDeleteModal(selectedRow) {
      this.resetAlerts();
      var roleNameGr = selectedRow.item.role_name;
      var roleName = "";
      roleName = this.translateToEn(roleNameGr);
      this.roleToDelete = roleName;
      this.selectedRow = selectedRow;
      esepService.getUserInfo(this.user.username).then(
        (response) => {
          let selectedUsersUnits = [];
          response.data.permissions.forEach((permission) => {
            if (selectedUsersUnits.length > 0) {
              let duplicateUnit = false;
              selectedUsersUnits.forEach((unit) => {
                if (unit.id == permission.unit.id) {
                  duplicateUnit = true;
                }
              });
              if (!duplicateUnit) {
                selectedUsersUnits.push({
                  id: permission.unit.id,
                  label: permission.unit.name,
                });
              }
            } else {
              selectedUsersUnits.push({
                id: permission.unit.id,
                label: permission.unit.name,
              });
            }
          });
          this.userPermissionUnits = selectedUsersUnits;
        },
        (error) => {
          this.errorMessage =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          console.log(error);
        }
      );
      this.$bvModal.show("delete-modal");
    },

    deleteConfirmed() {
      var username = this.user.username;
      var roleNameGr = this.selectedRow.item.role_name;
      var roleName = "";

      roleName = this.translateToEn(roleNameGr);
      EsepService.deleteRole(
        username,
        roleName,
        this.selectedPermissionUnit ? this.selectedPermissionUnit.id : null
      ).then(() => {
        for (var j = 0; j < this.rolesOfEachUser.length; j++) {
          if (this.rolesOfEachUser[j].role_name == roleNameGr) {
            this.rolesOfEachUser.splice(j, 1);
          }
        }
        this.roleToDelete = null;
        this.showSuccess = true;
        this.$bvModal.hide("delete-modal");
        location.reload();
      },
          () => {this.showFailed = true;}
      );
    },

    showAddModal: function () {
      this.resetAlerts();
      this.roleState = null;
      this.roles = [];
      this.$log.debug(this.$store.state.usersAccessibleUnits);
      EsepService.getAvailableRoles().then(
        (response) => {
          this.$log.debug(response.data);
          response.data.forEach((role) => {
            this.roles.push(this.translateToGr(role));
          });
        },
        (error) => {
          this.errorMessage =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          console.log(error);
        }
      );
      const selectedUsers = this.$store.state.selectedUsers;
      console.log("selectedUsers:");
      console.log(selectedUsers);
      if (selectedUsers.length < 1) {
        this.showFailed = true;
      } else {
        this.show = true;
      }
    },
    addRole: function () {
      var username = "";
      var roleName = "";
      var userId = 0;
      var roleNameGr = this.roleToAdd;
      // var rolesList = [];
      if (roleNameGr == null) {
        this.roleState = false;
      } else {
        roleName = this.translateToEn(roleNameGr);
        this.$store.state.selectedUsers.forEach(function (user) {
          // rolesList = user.roles;
          username = user.username;
          userId = user.id;
        });
        this.$log.debug(roleNameGr + roleName);
          this.$log.debug(this.selectedUnit);
          EsepService.assignRole(username, roleName, this.selectedUnit.id).then(
            (response) => {
              this.$log.debug(response);
              this.$log.debug(response.data);
              let unitName = null;
              if (
                roleName != "ADMIN" &&
                roleName != "FINANCE_ADMIN" &&
                roleName != "TRAINING_ADMIN" &&
                roleName != "TRAINER"
              ) {
                unitName = this.selectedUnit.label;
              } else {
                unitName = "-";
              }
              this.rolesOfEachUser.push({
                user_id: userId,
                role_name: roleNameGr,
                username: username,
                unit: unitName,
              });
              this.showSuccess = true;
              location.reload();
            },
              () => {
                this.showFailed = true;
              }
          );

        this.$bvModal.hide("add-role-modal");
      }
    },
    activateUser(){
      EsepService.enableUser(this.user.username, !this.user.enabled).then(
          (response) => {
            this.user.enabled = !this.user.enabled;
            makeToast(this.$bvToast, response.data.enabled? "Επιτυχής Ενεργοποίηση": "Επιτυχής Απενεργοποίηση");
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      );
    },
    verifyUser(){
      EsepService.verifyUser(this.user.username, true).then(
          () => {
            this.user.emailVerified = true;
            makeToast(this.$bvToast, "Επιτυχής Επιβεβαίωση");
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      );
    },
    extractRolesOfEachUser(rolesOfEachUser) {
      rolesOfEachUser.forEach((role) => {
        role.username = this.user.username;
      })
      this.rolesOfEachUser = rolesOfEachUser;
    },
    resetAlerts() {
      this.showSuccess = false;
      this.showFailed = false;
      this.showWarning = false;
    },
    translateToGr(role) {
      let roleName = "";
      if (role.name == "USER") {
        roleName = "Χρήστης";
      } else if (role.name == "ADMIN") {
        roleName = "Διαχειριστής Εφαρμογών E-SEP";
      } else if (role.name == "UNIT_ADMIN") {
        roleName = "Διαχειριστής Κλιμακίου";
      } else if (role.name == "UNIT_MOD") {
        roleName = "Συντονιστής Κλιμακίου";
      } else if (role.name == "TRAINING_ADMIN") {
        roleName = "Διαχειριστής Εφορείας Εκπαίδευσης ΓΕ";
      } else if (role.name == "FINANCE_ADMIN") {
        roleName = "Διαχειριστής Οικονομικής Υπηρεσίας ΣΕΠ";
      } else if (role.name == "TRAIN_MOD") {
        roleName = "Συντονιστής Εκπαίδευσης";
      } else if (role.name == "TRAINER") {
        roleName = "Εκπαιδευτής";
      } else if (role.name == "UNIT_VIEWER") {
        roleName = "Επόπτης Κλιμακίου";
      } else if (role.name == "TROOP_ADMIN") {
        roleName = "Διαχειριστής Τμήματος";
      } else if (role.name == "CAPTAIN") {
        roleName = "Κυβερνήτης";
      } else if (role.name == "COMMISSION_PRESIDENT") {
        roleName = "Πρόεδρος Ε.Κ.Σ.";
      } else if (role.name == "EXCURSION_VIEWER") {
        roleName = "Επόπτης Δελτίων Εκδρομών";
      } else if (role.name == "AFFAIRS_COMMISSIONER") {
        roleName = "Συντονιστής Εφορείας Διεθνών Σχέσεων";
      } else if (role.name == "NAVY_COMMISSIONER") {
        roleName = "Συντονιστής Ειδικότητας Ναυτοπροσκόπων";
      } else if (role.name == "BRANCH_COMMISSIONER") {
        roleName = "Έφορος Κλάδου";
      } else if (role.name == "AIR_COMMISSIONER") {
        roleName = "Συντονιστής Ειδικότητας Αεροπροσκόπων";
      }
      return roleName;
    },
    translateToEn(roleNameGr) {
      let roleName = "";
      if (roleNameGr == "Χρήστης") {
        roleName = "USER";
      } else if (roleNameGr == "Διαχειριστής Εφαρμογών E-SEP") {
        roleName = "ADMIN";
      } else if (roleNameGr == "Διαχειριστής Κλιμακίου") {
        roleName = "UNIT_ADMIN";
      } else if (roleNameGr == "Διαχειριστής Εφορείας Εκπαίδευσης ΓΕ") {
        roleName = "TRAINING_ADMIN";
      } else if (roleNameGr == "Διαχειριστής Οικονομικής Υπηρεσίας ΣΕΠ") {
        roleName = "FINANCE_ADMIN";
      } else if (roleNameGr == "Συντονιστής Κλιμακίου") {
        roleName = "UNIT_MOD";
      } else if (roleNameGr == "Συντονιστής Εκπαίδευσης") {
        roleName = "TRAIN_MOD";
      } else if (roleNameGr == "Εκπαιδευτής") {
        roleName = "TRAINER";
      } else if (roleNameGr == "Επόπτης Κλιμακίου") {
        roleName = "UNIT_VIEWER";
      } else if (roleNameGr == "Διαχειριστής Τμήματος") {
        roleName = "TROOP_ADMIN";
      } else if (roleNameGr == "Κυβερνήτης") {
        roleName = "CAPTAIN";
      } else if (roleNameGr == "Πρόεδρος Ε.Κ.Σ.") {
        roleName = "COMMISSION_PRESIDENT";
      } else if (roleNameGr == "Επόπτης Δελτίων Εκδρομών") {
        roleName = "EXCURSION_VIEWER";
      } else if (roleNameGr == "Συντονιστής Εφορείας Διεθνών Σχέσεων") {
        roleName = "AFFAIRS_COMMISSIONER";
      } else if (roleNameGr == "Συντονιστής Ειδικότητας Ναυτοπροσκόπων") {
        roleName = "NAVY_COMMISSIONER";
      } else if (roleNameGr == "Έφορος Κλάδου") {
        roleName = "BRANCH_COMMISSIONER";
      } else if (roleNameGr == "Συντονιστής Ειδικότητας Αεροπροσκόπων") {
        roleName = "AIR_COMMISSIONER";
      }
      return roleName;
    },
  },
};
</script>